export const main_icon = require('./main_icon.svg').default;
export const projects_icon = require('./projects_icon.svg').default;
export const team_icon = require('./team_icon.svg').default;
export const news_icon = require('./news_icon.svg').default;
export const partners_icon = require('./partners_icon.svg').default;
export const close_icon = require('./close_icon.svg').default;
